import { useTypedQueryParams } from "@/layout/utils/useTypedQueryParams";
import { PaymentResultQuery } from "@/features/payment/wallet/domain/payment.interface";
import PaymentResultCard from "@/features/payment/wallet/presentation/components/payment-result/PaymentResultCard";

interface PaymentResultProps {}

const PaymentResult = ({}: PaymentResultProps) => {
  const queryParams = useTypedQueryParams<PaymentResultQuery>();

  return (
    <div className="flex flex-row w-full h-[100vh] overflow-hidden items-center justify-between px-[6vw] agrobg gap-16">
      <PaymentResultCard
        paymentResultType={
          queryParams.status === "verified"
            ? "WALLET_CHARGE_SUCCESS"
            : "WALLET_CHARGE_FAILED"
        }
        paymentTrackingRoute={queryParams.returnTo}
        paymentResult={queryParams}
      />
    </div>
  );
};

export default PaymentResult;
